import { decode } from 'string-encode-decode';

export default function decodeCache(id) {
  if (!localStorage.getItem(id)) return null;
  const item = decode(localStorage.getItem(id));
  return JSON.parse(item);
}
